import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function CenterMode({ sliderData }) {
  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "40px",
    slidesToShow: 3,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 1500,
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true,
    infinite: true,
  };

  return (
    <div
      className="slider-container"
      style={{ width: "30%", margin: "0 auto", overflow: "hidden" }}
    >
      <Slider {...settings}>
        {sliderData?.map((v, i) => {
          return (
            <div>
              <img
                src={v.imgUrl}
                alt="Slide 1"
                style={{ width: "30%", height: "80px" }}
                className="object-center"
              />
            </div>
          );
        })}
      </Slider>


    </div>
  );
}

export default CenterMode;
